import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { pmApi, PRIORITIES, STATUS_FLOW } from '../../lib/pmApi';
import { Siren } from 'lucide-react';

const WorkOrders = () => {
  const [params, setParams] = useSearchParams();
  const [list, setList] = useState([]);
  const [filters, setFilters] = useState({
    status: params.get('status') || '',
    priority: params.get('priority') || '',
  });

  useEffect(() => {
    const q = {};
    if (filters.status) q.status = filters.status;
    if (filters.priority) q.priority = filters.priority;
    pmApi.listRequests(q).then(setList).catch(() => setList([]));
  }, [filters]);

  const setFilter = (k, v) => {
    setFilters((f) => ({ ...f, [k]: v }));
    if (v) params.set(k, v); else params.delete(k);
    setParams(params, { replace: true });
  };

  return (
    <div data-testid="pm-work-orders-page" className="p-6 max-w-7xl space-y-6">
      <div>
        <p className="text-[#D4AF37] text-xs font-bold tracking-[0.3em] mb-1">WORK ORDERS</p>
        <h1 className="font-['Outfit'] text-3xl font-bold text-white">Work Orders</h1>
      </div>

      <div className="flex flex-wrap gap-3">
        <select data-testid="pm-wo-filter-status" value={filters.status} onChange={(e) => setFilter('status', e.target.value)} className="bg-[#0A0A0A] border border-[#262626] rounded h-10 px-3 text-white text-sm">
          <option value="">All statuses</option>
          {STATUS_FLOW.map((s) => <option key={s}>{s}</option>)}
        </select>
        <select data-testid="pm-wo-filter-priority" value={filters.priority} onChange={(e) => setFilter('priority', e.target.value)} className="bg-[#0A0A0A] border border-[#262626] rounded h-10 px-3 text-white text-sm">
          <option value="">All priorities</option>
          {PRIORITIES.map((p) => <option key={p}>{p}</option>)}
        </select>
        <Link to="/pm/submit" className="ml-auto bg-[#D4AF37] text-[#0A0A0A] px-4 py-2 rounded font-medium hover:bg-[#F3E5AB] text-sm">+ Submit Request</Link>
      </div>

      <div className="bg-[#141414] border border-[#262626] rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#0A0A0A] text-[#A3A3A3]">
            <tr>
              <th className="p-3 text-left">WO #</th>
              <th className="p-3 text-left">Property</th>
              <th className="p-3 text-left">Unit</th>
              <th className="p-3 text-left">Priority</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Technician</th>
              <th className="p-3 text-left">Submitted</th>
            </tr>
          </thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.id} data-testid={`pm-wo-row-${r.id}`} className={`border-t border-[#262626] hover:bg-[#1a1a1a] ${r.priority === 'Emergency' ? 'bg-[#7F1D1D]/10' : ''}`}>
                <td className="p-3"><Link to={`/pm/work-orders/${r.id}`} className="text-[#D4AF37] hover:text-[#F3E5AB] font-mono text-xs">{r.work_order_number}</Link></td>
                <td className="p-3 text-white">{r.property_name}</td>
                <td className="p-3 text-[#A3A3A3]">{r.unit_number || '—'}</td>
                <td className="p-3">
                  <span className={`text-xs font-medium px-2 py-1 rounded ${r.priority === 'Emergency' ? 'bg-[#EF4444]/15 text-[#EF4444]' : r.priority === 'High' ? 'bg-[#D4AF37]/15 text-[#D4AF37]' : 'bg-[#262626] text-[#A3A3A3]'}`}>
                    {r.priority === 'Emergency' && <Siren className="w-3 h-3 inline-block mr-1" />}{r.priority}
                  </span>
                </td>
                <td className="p-3 text-white text-xs">{r.status}</td>
                <td className="p-3 text-[#A3A3A3]">{r.assigned_technician_name || '—'}</td>
                <td className="p-3 text-[#525252] text-xs">{r.created_at ? new Date(r.created_at).toLocaleString() : ''}</td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={7} className="p-6 text-center text-[#525252]">No work orders found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WorkOrders;
